var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import MuiIconButton from '@material-ui/core/IconButton';
/**
 * Kareo wrapped component of the Material-UI IconButton. The prop API has been limited to props defined in IconButtonProps
 *
 * Material-UI IconButton: [Docs](https://v4.mui.com/components/buttons/), [API](https://v4.mui.com/api/icon-button/)
 *
 * @storybook: [IconButton](http://design.kareoprod.ent/design-system/?path=/story/components-data-display-iconbutton--icon-button-example)
 */
var IconButton = function (props) {
    return React.createElement(MuiIconButton, __assign({}, props));
};
IconButton.defaultProps = {};
IconButton.displayName = 'KareoIconButton';
export default IconButton;
